import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../../../app.config';
import { urlJoin } from '../../../../core/helpers/url.helper';
import { Observable } from 'rxjs';
import { GarageResponse, SivSearch } from './esiv.model';

@Injectable({
  providedIn: 'root'
})
export class EsivService {
  private readonly httpClient = inject(HttpClient);
  private readonly appConfig = inject(AppConfig);

  private readonly url = urlJoin(this.appConfig.url, 'esiv');

  fetchVehicle(sivSearch: SivSearch): Observable<Record<string, GarageResponse>> {
    return this.httpClient.post<Record<string, GarageResponse>>(urlJoin(this.url, `garages`), sivSearch);
  }
}
